import CustomInterval from './CustomInterval';
export default CustomInterval;